module.exports = __webpack_public_path__ + "static/img/jipin.3eefeb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jipin.png
// module id = gG7h
// module chunks = 1